const comments = [
  {
    name: '追剧小王',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20man%20with%20friendly%20expression%2C%20clean%20minimal%20studio%20background%20with%20soft%20neutral%20lighting%2C%20modern%20casual%20style%2C%20high%20quality%20corporate%20portrait%20photography%20with%20shallow%20depth%20of%20field&width=80&height=80&seq=avatar-user-01&orientation=squarish',
    role: '资深剧迷',
    content: '成全影院真的太好用了！更新速度超快，画质清晰流畅，每天晚上回家打开就能看最新剧集，再也不用到处找资源了。强烈推荐给所有追剧的朋友！',
    time: '2小时前',
  },
  {
    name: '电影爱好者阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20man%20in%20late%20twenties%20with%20confident%20smile%2C%20clean%20studio%20lighting%20on%20plain%20neutral%20background%2C%20modern%20business%20casual%20attire%2C%20warm%20friendly%20expression%2C%20high%20quality%20portrait%20photography&width=80&height=80&seq=avatar-user-02&orientation=squarish',
    role: '电影达人',
    content: '片库太全了！各种类型都有，从经典老片到最新院线都能找到。画质清晰不卡顿，投屏到电视上效果超赞，周末在家就能享受影院级观影体验。',
    time: '5小时前',
  },
  {
    name: '综艺控小雨',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%20with%20warm%20genuine%20smile%2C%20soft%20natural%20studio%20lighting%20on%20clean%20neutral%20background%2C%20modern%20minimal%20style%2C%20friendly%20approachable%20expression%2C%20high%20quality%20editorial%20portrait%20photography&width=80&height=80&seq=avatar-user-03&orientation=squarish',
    role: '综艺迷',
    content: '综艺更新速度简直神了！当天播出当天就能看，再也不用等第二天了。成全影院就是我追综艺的快乐源泉，感谢有这么一个好平台！',
    time: '8小时前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-accent-400 mb-3">REVIEWS</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">用户反馈</h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-[500px] mx-auto">听听影迷们怎么说成全影院</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-[1000px] mx-auto">
            {comments.map((c, i) => (
              <div key={i} className="bg-background-100 rounded-xl p-6 border border-background-200/40">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-11 h-11 rounded-full overflow-hidden border-2 border-primary-500/30 flex-shrink-0">
                    <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-100">{c.name}</div>
                    <div className="text-xs text-primary-400">{c.role}</div>
                  </div>
                </div>
                <p className="text-sm text-foreground-400 leading-relaxed mb-4">{c.content}</p>
                <div className="text-xs text-foreground-600">{c.time}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}